import React from 'react';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAfterSubmitAction, processForm, resetFormData } from '#action/shipment/form';

/**
 * Renders save button.
 * Dispatches action to process form data.
 */

const SaveButton = props => {
  const { disabled, isAnyChanged, ...rest } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const handleClick = () => {
    const action = async () => {
      const { success, id: shipmentId } = await dispatch(processForm());
      if (success) {
        history.push(`/shipment/${shipmentId}`);
        dispatch(resetFormData());
      }
    };

    dispatch(setAfterSubmitAction(action));
  };

  const isDisabled = disabled || (isAnyChanged === false);

  return (
    <Button
      disabled={isDisabled}
      type="submit"
      variant="contained"
      color="secondary"
      {...rest}
      onClick={handleClick}
    >
      Save
    </Button>
  );
};

export default SaveButton;
